import Parse from "parse";

export default async function getUserSubscription() {
  const {
    subscription: userSubscription,
    cancelSubscriptionUrl,
    manageSubscriptionUrl
  } = await Parse.Cloud.run("getCloudAccountInfo");

  if (userSubscription == null) {
    return null;
  }

  delete userSubscription.user;

  if (cancelSubscriptionUrl) userSubscription.cancelUrl = cancelSubscriptionUrl;
  if (manageSubscriptionUrl) userSubscription.updateUrl = manageSubscriptionUrl;

  return userSubscription;
}
